import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ScaleTicketDetailServiceBase } from 'scaletech-tickets';
import { WebApiService } from 'starbase-login';

@Injectable({
  providedIn: 'root'
})
export class ScaleTicketDetailDataService extends ScaleTicketDetailServiceBase {

  constructor(http: HttpClient, webApi: WebApiService) {
    super(http, webApi);
  }
}
